import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles/fonts.css";
import "./styles/tokens.css";
import "./styles/app.css";
import "./styles/screens.css";
import { App } from "./app/App";
import { installDiagnostics } from "./features/feedback/diagnostics";
import { installStaleChunkReload } from "./shared/lib/staleChunk";

// Pin feedback's client log (console errors and warnings, API calls; redacted, bounded ring buffers). Installed before
// the app renders so a report can show what went wrong on the way to the screen. Cheap, and inert until a report reads it.
installDiagnostics();
// Batch 13: a screen file of an older build gone after a deploy reloads the page once instead of failing (staleChunk.ts).
installStaleChunkReload();

const container = document.getElementById("root");
if (!container) {
  throw new Error("index.html is missing the #root element");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
